import Request from "@/utils/request";

const { postFree, postWeb } = new Request("koala");

/**
 * 接受邀请
 * @param {object} params
 */
export function fetchAcceptInvite(params) {
  return postWeb("/web/user-invite/email-accept", params);
}

/**
 * 获取农场信息
 * @param {object} params
 */
export function fetchGetFarmDetail(params) {
  return postFree("/web/user-invite/email-invite-info", params, {
    closeTips: true,
  });
}

/**
 * 获取农场地图数据
 * @param {object} params
 */
export function fetchGetMapData(params) {
  return postFree("/web/share/detail", params);
}

/**
 * 微信签名
 * @param {url} params 
 */
export function fetchWeChatJsSdkConfig(params) {
  return postFree('/mobile/wx/signature', params, {
    closeTips: true,
  })
}

/**
 * 更新微信签名
 * @param {*} params 
 */
export function fetchWeChatJsSdkRefresh(params) {
  return postFree('/mobile/wx/refreshSignature', params)
}
